/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated.index'
import { Route as AuthCallbackImport } from './routes/auth.callback'
import { Route as AuthenticatedSearchImport } from './routes/_authenticated.search'
import { Route as AuthenticatedApiExplorerImport } from './routes/_authenticated.api-explorer'
import { Route as AuthenticatedApiExplorerIndexImport } from './routes/_authenticated.api-explorer.index'
import { Route as AuthenticatedSearchQueryConsoleImport } from './routes/_authenticated.search.query-console'
import { Route as AuthenticatedSearchIndexesImport } from './routes/_authenticated.search.indexes'
import { Route as AuthenticatedSearchForceUpdateImport } from './routes/_authenticated.search.force-update'
import { Route as AuthenticatedApiExplorerServiceImport } from './routes/_authenticated.api-explorer.$service'

// Create/Update Routes

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSearchRoute = AuthenticatedSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedApiExplorerRoute = AuthenticatedApiExplorerImport.update({
  id: '/api-explorer',
  path: '/api-explorer',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedApiExplorerIndexRoute =
  AuthenticatedApiExplorerIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedApiExplorerRoute,
  } as any)

const AuthenticatedSearchQueryConsoleRoute =
  AuthenticatedSearchQueryConsoleImport.update({
    id: '/query-console',
    path: '/query-console',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedSearchIndexesRoute = AuthenticatedSearchIndexesImport.update(
  {
    id: '/indexes',
    path: '/indexes',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any,
)

const AuthenticatedSearchForceUpdateRoute =
  AuthenticatedSearchForceUpdateImport.update({
    id: '/force-update',
    path: '/force-update',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedApiExplorerServiceRoute =
  AuthenticatedApiExplorerServiceImport.update({
    id: '/$service',
    path: '/$service',
    getParentRoute: () => AuthenticatedApiExplorerRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/api-explorer': {
      id: '/_authenticated/api-explorer'
      path: '/api-explorer'
      fullPath: '/api-explorer'
      preLoaderRoute: typeof AuthenticatedApiExplorerImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchImport
      parentRoute: typeof AuthenticatedImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/api-explorer/$service': {
      id: '/_authenticated/api-explorer/$service'
      path: '/$service'
      fullPath: '/api-explorer/$service'
      preLoaderRoute: typeof AuthenticatedApiExplorerServiceImport
      parentRoute: typeof AuthenticatedApiExplorerImport
    }
    '/_authenticated/search/force-update': {
      id: '/_authenticated/search/force-update'
      path: '/force-update'
      fullPath: '/search/force-update'
      preLoaderRoute: typeof AuthenticatedSearchForceUpdateImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/indexes': {
      id: '/_authenticated/search/indexes'
      path: '/indexes'
      fullPath: '/search/indexes'
      preLoaderRoute: typeof AuthenticatedSearchIndexesImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/query-console': {
      id: '/_authenticated/search/query-console'
      path: '/query-console'
      fullPath: '/search/query-console'
      preLoaderRoute: typeof AuthenticatedSearchQueryConsoleImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/api-explorer/': {
      id: '/_authenticated/api-explorer/'
      path: '/'
      fullPath: '/api-explorer/'
      preLoaderRoute: typeof AuthenticatedApiExplorerIndexImport
      parentRoute: typeof AuthenticatedApiExplorerImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedApiExplorerRouteChildren {
  AuthenticatedApiExplorerServiceRoute: typeof AuthenticatedApiExplorerServiceRoute
  AuthenticatedApiExplorerIndexRoute: typeof AuthenticatedApiExplorerIndexRoute
}

const AuthenticatedApiExplorerRouteChildren: AuthenticatedApiExplorerRouteChildren =
  {
    AuthenticatedApiExplorerServiceRoute: AuthenticatedApiExplorerServiceRoute,
    AuthenticatedApiExplorerIndexRoute: AuthenticatedApiExplorerIndexRoute,
  }

const AuthenticatedApiExplorerRouteWithChildren =
  AuthenticatedApiExplorerRoute._addFileChildren(
    AuthenticatedApiExplorerRouteChildren,
  )

interface AuthenticatedSearchRouteChildren {
  AuthenticatedSearchForceUpdateRoute: typeof AuthenticatedSearchForceUpdateRoute
  AuthenticatedSearchIndexesRoute: typeof AuthenticatedSearchIndexesRoute
  AuthenticatedSearchQueryConsoleRoute: typeof AuthenticatedSearchQueryConsoleRoute
}

const AuthenticatedSearchRouteChildren: AuthenticatedSearchRouteChildren = {
  AuthenticatedSearchForceUpdateRoute: AuthenticatedSearchForceUpdateRoute,
  AuthenticatedSearchIndexesRoute: AuthenticatedSearchIndexesRoute,
  AuthenticatedSearchQueryConsoleRoute: AuthenticatedSearchQueryConsoleRoute,
}

const AuthenticatedSearchRouteWithChildren =
  AuthenticatedSearchRoute._addFileChildren(AuthenticatedSearchRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedApiExplorerRoute: typeof AuthenticatedApiExplorerRouteWithChildren
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedApiExplorerRoute: AuthenticatedApiExplorerRouteWithChildren,
  AuthenticatedSearchRoute: AuthenticatedSearchRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/api-explorer': typeof AuthenticatedApiExplorerRouteWithChildren
  '/search': typeof AuthenticatedSearchRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/api-explorer/': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/search': typeof AuthenticatedSearchRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/api-explorer': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_authenticated/api-explorer': typeof AuthenticatedApiExplorerRouteWithChildren
  '/_authenticated/search': typeof AuthenticatedSearchRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/_authenticated/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/_authenticated/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/_authenticated/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/_authenticated/api-explorer/': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/logout'
    | '/api-explorer'
    | '/search'
    | '/auth/callback'
    | '/'
    | '/api-explorer/$service'
    | '/search/force-update'
    | '/search/indexes'
    | '/search/query-console'
    | '/api-explorer/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/logout'
    | '/search'
    | '/auth/callback'
    | '/'
    | '/api-explorer/$service'
    | '/search/force-update'
    | '/search/indexes'
    | '/search/query-console'
    | '/api-explorer'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/logout'
    | '/_authenticated/api-explorer'
    | '/_authenticated/search'
    | '/auth/callback'
    | '/_authenticated/'
    | '/_authenticated/api-explorer/$service'
    | '/_authenticated/search/force-update'
    | '/_authenticated/search/indexes'
    | '/_authenticated/search/query-console'
    | '/_authenticated/api-explorer/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/login",
        "/logout",
        "/auth/callback"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/api-explorer",
        "/_authenticated/search",
        "/_authenticated/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/_authenticated/api-explorer": {
      "filePath": "_authenticated.api-explorer.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/api-explorer/$service",
        "/_authenticated/api-explorer/"
      ]
    },
    "/_authenticated/search": {
      "filePath": "_authenticated.search.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/search/force-update",
        "/_authenticated/search/indexes",
        "/_authenticated/search/query-console"
      ]
    },
    "/auth/callback": {
      "filePath": "auth.callback.tsx"
    },
    "/_authenticated/": {
      "filePath": "_authenticated.index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/api-explorer/$service": {
      "filePath": "_authenticated.api-explorer.$service.tsx",
      "parent": "/_authenticated/api-explorer"
    },
    "/_authenticated/search/force-update": {
      "filePath": "_authenticated.search.force-update.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/indexes": {
      "filePath": "_authenticated.search.indexes.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/query-console": {
      "filePath": "_authenticated.search.query-console.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/api-explorer/": {
      "filePath": "_authenticated.api-explorer.index.tsx",
      "parent": "/_authenticated/api-explorer"
    }
  }
}
ROUTE_MANIFEST_END */
